import EXERCISES_UI_ACTION from '../../constants/action'
import EXERCISES_PATH from '../../constants/path'
import setReduxAction from '../../../redux/actions/set'

export function updateEquipmentFilterExercisesAction (values) {
  return (dispatch) => {
    dispatch(setReduxAction({
      type: EXERCISES_UI_ACTION.UPDATE_EQUIPMENT_FILTER,
      payload: {
        path: EXERCISES_PATH.EQUIPMENT_FILTER,
        value: values
      }
    }))
  }
}
